import React from 'react';

const BurgerRight = () => (
  <svg width="32" height="28" viewBox="0 0 32 28">
    <path
      d="M30.5 28h-10c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5ZM30.5 20h-17c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h17c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5ZM30.5 12h-22c-.83 0-1.5-.67-1.5-1.5S7.67 9 8.5 9h22c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5ZM30.5 3h-29C.67 3 0 2.33 0 1.5S.67 0 1.5 0h29c.83 0 1.5.67 1.5 1.5S31.33 3 30.5 3Z"
      style={{ fill: 'currentColor' }}
    />
  </svg>
);

export default BurgerRight;
